<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent theme-color main-toolbar"
    :style="setBgImage()"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
      'is-not-main-page': $route.name !== 'Main',
      'is-white-bg': !brandBackground
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          <template v-if="$checkMobile()">
            <router-link
              v-if="$route.meta.backRoute"
              :to="{ name: $route.meta.backRoute.name }"
              class="back-route-link only-mobile"
            >
              <md-icon>arrow_back_ios</md-icon>
            </router-link>
            <span v-if="this.$route.name !== 'Main'">
              <template v-if="this.$route.name === 'AppealsDetail'">
                {{ getCurrentAppealMeta.label }}
              </template>
              <template v-else-if="this.$route.name === 'NewsDetailPage'">
                {{ getCurrentNewsType }}
              </template>
              <template v-else>
                {{ this.$route.meta.name }}
              </template>
            </span>
          </template>

          <template v-else>
            <span>{{ address }}</span>
          </template>
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <div class="md-collapse mobile-menu">
          <md-list>
            <li v-if="!($checkMobile() && $route.name !== 'Main')" class="md-list-item">
              <a
                href="#"
                @click.native.prevent="
                  {
                  }
                "
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down" :class="{'visibility-hidden': $checkMobile() && $route.name !== 'Main'}" >
                    <md-button
                      slot="title"
                      class="md-button md-simple menu-button"
                      data-toggle="dropdown"
                    >
                      <md-icon>menu</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <template v-if="getPersonalAccounts">
                        <li class="dropdown-menu-label">Аккаунты</li>
                        <li
                          v-for="(acc, i) in getPersonalAccounts"
                          :key="i"
                        >
                          <a href="#" @click.prevent="$emit('onChangeAccount', acc.key)">
                            <i
                              class="material-icons custom-icon active-check-icon"
                              :class="{'visible-icon': acc.key === authToken }"
                            >check</i>
                            {{ acc.address }}
                          </a>
                        </li>
                        <li class="dropdown-menu-divider"></li>
                      </template>
                      <li>
                        <router-link :to="{ name: 'Feedback' }">
                          <i class="material-icons custom-icon">report_gmailerrorred</i>
                          Сообщить об ошибке
                        </router-link>
                      </li>
                      <li>
                        <router-link :to="{ name: 'Logout' }">
                          <i class="material-icons custom-icon">exit_to_app</i>
                          Выйти
                        </router-link>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
            <li v-if="$checkMobile() && $route.name === 'Appeals'" class="md-list-item">
              <div class="md-list-item-router md-list-item-container">
                <a
                  href="#"
                  class="add-appeal-button"
                  @click.prevent="$root.$emit('createAppeal')"
                >
                  <md-icon>add</md-icon>
                </a>
              </div>
            </li>
            <li
              v-if="$checkMobile() && $route.name === 'AppealsDetail' && getCurrentAppealMeta.ratingAwaiting"
              class="md-list-item"
            >
              <div class="md-list-item-router md-list-item-container">
                <a
                  href="#"
                  class="add-appeal-button"
                  @click.prevent="$root.$emit('createAppeal')"
                >
                  <md-icon>star</md-icon>
                </a>
              </div>
            </li>
            <li v-if="$checkMobile() && $route.name === 'Contacts'" class="md-list-item">
              <a
                href="#"
                @click.native.prevent="
                  {
                  }
                "
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-simple dots-button"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_vert</md-icon>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li>
                        <router-link :to="{ name: 'Feedback' }">
                          Сообщить об ошибке
                        </router-link>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

          </md-list>
        </div>
      </div>
    </div>
    <div v-if="!brandBackground" class="logo-icon-row">
      <img
        :src="brandLogo"
        alt="logo"
      >
    </div>
    <div class="address-label-mobile">
      {{ address }}
    </div>
  </md-toolbar>
</template>

<script>
import {mapGetters} from "vuex";
import config from "@/config";

export default {
  props: {
    profileName: {
      type: String,
      default: null
    },
    profileNameOrg: {
      type: String,
      default: null
    }
  },
  watch: {
    '$route': {
      handler() {
        this.setBgImage()
      }
    }
  },
  computed: {
    ...mapGetters([
      'getPersonalAccountInfo',
      'getPersonalAccounts',
      'getManageOrganizationInfo',
      'getCurrentAppealMeta',
      'getCurrentNewsType',
      'authToken'
    ]),

    brandLogo() {
      const host = config.site.host;
      const { logo } = this.getManageOrganizationInfo;
      return logo ? `${host}${logo}` : 'https://storage.yandexcloud.net/mdo-assets/icons/mdo_icon_480_435.png';
    },

    brandBackground() {
      const host = config.site.host;
      const { background } = this.getManageOrganizationInfo;
      return background ? `${host}${background}` : null;
    },

    account() {
      if (this.getPersonalAccountInfo) {
        const personalAccount = this.getPersonalAccountInfo.personalAccount.number;

        return `ЛС ${personalAccount}`
      }
    },

    address() {
      if (this.getPersonalAccountInfo) {
        const street = this.getPersonalAccountInfo.apartment.thoroughfare;
        const premise = this.getPersonalAccountInfo.apartment.premise;
        const objectName = this.getPersonalAccountInfo.apartment.objectname;
        const apartment = this.getPersonalAccountInfo.apartment.number;
        return `${street} ${premise}, ${objectName} ${apartment}`;
      }
      return "";
    },
  },
  methods: {
    setBgImage() {
      if (window.innerWidth > 768) {
        return {};
      }

      if (this.$route.name === 'Main') {
        if (this.brandLogo) {
          return {
            backgroundColor: '#fff !important'
          }
        } else {
          if (this.brandBackground) {
            return {
              background: `linear-gradient(to right, #00000066, #00000066), url(${this.brandBackground})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            };
          } else {
            return {
              background: 'linear-gradient(to right, #00000066, #00000066), url("./img/ekb_panorama.jpg")',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
            }
          }
        }
      }
      return {};
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  }
};
</script>
<style lang="scss">
.main-toolbar {
  .dots-button:not(.md-just-icon):not(.md-btn-fab):not(.md-icon-button):not(.md-toolbar-toggle) .md-ripple,
  .dots-button:not(.md-just-icon):not(.md-btn-fab):not(.md-icon-button):not(.md-toolbar-toggle) .md-ripple {
    @media (max-width: 768px) {
      padding: 10px;
    }
  }
}
</style>
<style scoped lang="scss">
.main-toolbar {
  transition: unset;
  min-height: 65px;
  @media (max-width: 768px) {
    box-shadow: unset;
  }
  .md-toolbar-section-start {
    @media (max-width: 768px) {
      position: absolute;
      left: 15px;
      top: 8px;
    }
  }
  .md-toolbar-section-end {
    @media (max-width: 768px) {
      position: absolute;
      right: 8px;
      top: 8px;
    }
  }
  .address-label-mobile {
    display: none;
    width: 100%;
    text-align: center;
    background-color: #ffffffb3;
    color: var(--md-theme-text-black-color);
    padding: 15px 10px;
    font-weight: 500;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .add-appeal-button {
    height: 50px;
    display: flex;
    width: 45px;
    justify-content: center;
    align-items: center;
    .md-icon {
      color: #ffffff !important;
      font-size: 32px !important;
    }
  }
  .menu-button {
    @media (max-width: 768px) {
      background-color: #ffffff !important;
      min-width: 45px;
      width: 45px;
      border-radius: 10px;
    }
    .md-icon {
      color: #ffffff !important;
      font-size: 32px !important;
      @media (max-width: 768px) {
        color: var(--md-theme-main-bar-color) !important;
      }
    }
  }
  .dots-button {
    min-width: 45px;
    width: 45px;
    border-radius: 10px;
    .md-icon {
      color: #ffffff !important;
      font-size: 32px !important;
    }
  }
  .active-check-icon {
    visibility: hidden;
  }
  .visible-icon {
    visibility: unset;
  }
  .logo-icon-row {
    display: none;
    width: 100%;
    text-align: center;
    @media (max-width: 768px) {
      display: block;
    }
    img {
      height: 115px;
    }
  }
}
.main-toolbar:not(.is-not-main-page) {
  @media (max-width: 768px) {
    min-height: 215px;
    align-content: space-between;
    padding: 10px 0 0 0;
    border-bottom: 1px solid #eee;
  }
}
.is-not-main-page {
  .logo-icon-row,
  .address-label-mobile {
    @media (max-width: 768px) {
      display: none;
    }
  }
}
.only-mobile {
  @media (min-width: 992px) {
    display: none;
  }
}

.mobile-menu {
  @media (max-width: 991px) {
    display: block !important;
    width: unset;
  }
}
.back-route-link {
  color: #ffffff !important;
  .md-icon {
    color: #ffffff !important;
  }
}

.custom-icon {
  margin-right: 20px;
}

.user-title {
  font-size: 12px;
  text-transform: inherit;
  margin-left: 5px;
  color: #ffffff;
}
.go-back-icon {
  color: #ffffff !important;
}
.dropdown-menu-label {
  padding: 10px 15px;
  color: #aaa;
  cursor: default;
}
.dropdown-menu-divider {
  height: 1px;
  background-color: #eee;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: default;
}
</style>
